import React from 'react';
import { connect } from 'react-redux'

import './TicketManagement.css'

import Time from '../../queuing/content/time/Time'
import TimeFormatter from '../../queuing/content/time/TimeFormatter'
import CallTicket from '../../queuing/content/manageTickets/CallTicket';
import CompleteTicket from '../../queuing/content/manageTickets/CompleteTicket';
import NoShowTicket from '../../queuing/content/manageTickets/NoShowTicket';
import TransferTicket from '../../queuing/content/manageTickets/TransferTicket';
import ReissueTicket from '../../queuing/content/manageTickets/ReissueTicket';
import ReQueueTicket from '../../queuing/content/manageTickets/ReQueueTicket';
import AssistTicketDirect from '../../queuing/content/manageTickets/AssitTicketDirect';

import { MANAGEMENT_LOCK } from '../../../store/constants';
import { getReissueDisplayInfo, isSupervisorUser } from '../../../store/helpers';

class TicketManagement extends React.Component {

    render(){
        const { activeTicketId, activeManagementTicketId, tickets, customers, services, users, sessions, supportDesks, authenticatedUser, supportDeskId } = this.props
        // my active ticket
        const myActiveTicket = tickets.find( data => data.id === activeTicketId )
        // Ticket details
        const ticket = tickets.find( ticket => ticket.id === activeManagementTicketId )

        // Guard: the modal can be open while the target ticket is absent from the
        // store (e.g. after a reload/PWA update clears tickets + activeManagementTicketId,
        // or after another agent completes/deletes the ticket). Without this guard every
        // ticket.* access below throws and white-screens the whole app.
        if( ticket == null ){
            return null
        }

        // customer details
        const customer = customers.find( data => data.mobileNumber === ticket.mobileNumber)

        // service details
        var service = services.find( data => data.id === ticket.serviceId )
        var serviceName = service != null
            ?   service.name 
            :   null
        const reissueInfo = getReissueDisplayInfo(ticket, tickets);
        const queueCreated = reissueInfo ? reissueInfo.originalCreated : Number(ticket.created);
        
        // agent details only active tickets
        const agent = ticket.status
            ?   users.find( agent => agent.id === ticket.manage.userId )
            :   ticket.manage != null
                ?   ticket.manage.userId != null
                    ?   users.find( agent => agent.id === ticket.manage.userId )
                    :   null
                :   null

        // agent supportDesk details only active tickets
        const supportDesk = ticket.status
        ?   supportDesks.find( supportDesk => supportDesk.id === ticket.manage.supportDeskId )
        :   ticket.manage != null
            ?   ticket.manage.supportDeskId != null
                ?   supportDesks.find( supportDesk => supportDesk.id === ticket.manage.supportDeskId )
                :   null
            :   null


        // is this an active ticket ?
        const isActiveTicket = Number(ticket.status) === 1
            ?   1
            :   0
        
        // is it my active ticket ?
        const isMyActiveTicket = activeTicketId === activeManagementTicketId
            ?   1
            :   0
        const isSupervisor = isSupervisorUser(authenticatedUser)
        const isRedZoneTicket = isSupervisor && isActiveTicket && !isMyActiveTicket

        // is it my service ?
        // const isMyService = ticket.serviceId === authenticatedUser.serviceId
        const isMyService = authenticatedUser.services.includes( ticket.serviceId )

        // transfered to a specific supportDesk / agent
        const isTransferedInit = !isActiveTicket && ticket.manage != null
        const isTransfered = isTransferedInit
            ?   ticket.manage.supportDeskId != null || ticket.manage.userId != null
            :   0

        const mySession = sessions.find( session => session.userId === authenticatedUser.id )

        // Transfered: is it my supportDesk ?
        const isTransferedToCounter = isTransfered
            ?   ticket.manage.supportDeskId != null
                ?   1
                :   0
            :   0 

        const isTransferedToMysupportDeskId = isTransferedToCounter
            ?   ticket.manage.supportDeskId === mySession.supportDeskId
                ?   1
                :   0
            :   0
        

        // Transfered: is it my userId ?
        const isTransferedToAgent = isTransfered && !isTransferedToCounter
            ?   1
            :   0

        const isTransferedToMyAgentId = isTransferedToAgent
            ?   ticket.manage.userId === authenticatedUser.id
                ?   1
                :   0
            :   0


        // kill code if ticket is closed
        if( ticket.status > 1 ){
            return (
                <>  
                    <h5>Ticket Management</h5>
                    <div className="informationContainer">
                        {
                            reissueInfo
                                ?   <div className="informationRow reissueTicketNotice">
                                        <label>Ticket Type</label>
                                        <span>Re-assigned Ticket</span>
                                    </div>
                                :   null
                        }
                        <div className="informationRow">
                            <label>Ticket Number</label>
                            <span>{ ticket.ticketLetter }{ ticket.ticketNumber }</span>
                        </div>
                        {
                            reissueInfo
                                ?   <div className="informationRow">
                                        <label>Re-assigned From</label>
                                        <span>{ reissueInfo.reissuedFromLabel }</span>
                                    </div>
                                :   null
                        }
                        {
                            reissueInfo
                                ?   <div className="informationRow">
                                        <label>Original Ticket</label>
                                        <span>{ reissueInfo.originalTicketLabel }</span>
                                    </div>
                                :   null
                        }
                        <div className="informationRow">
                            <label>Service</label>
                            <span>{ serviceName }</span>
                        </div>
                    </div>
                    <h5>Ticket was Closed</h5>
               </>
            )
        }
        
        // display banner for inactive tickets that are not in our service, unless transfered to my userId or supportDeskId.
        const callStatus = (
            isMyActiveTicket || 
            ( !isActiveTicket && !isTransfered && isMyService ) ||
            ( !isActiveTicket && isTransfered && (isTransferedToMysupportDeskId || isTransferedToMyAgentId) )    
        )

        const minHeight = {minHeight: 100}

        // find auth user supportDesk
        const authUserSupportDesk = supportDesks && Array.isArray(supportDesks) ? 
        supportDesks.find(desk => desk && desk.id === supportDeskId) : null;
    
        // authUserSupportDesk.backOfficeSupportDesk determines the layout for now
        const lock = authUserSupportDesk?.backOfficeSupportDesk === 1
        ? MANAGEMENT_LOCK.packageTracking
        : MANAGEMENT_LOCK.default;
        console.log(lock);
        
        return (
            <>  
               <h5>Ticket Management</h5>

               {
                    // alert to show that the user is already on a call and cannot call another ticket
                    callStatus && 
                    ( 
                        (activeTicketId != null && !isActiveTicket )  
                    ) 
                        ?   <div className="alertContainer scheme-pinkred-bg">You are already on a call with <span>Ticket { myActiveTicket.ticketLetter + "-" + myActiveTicket.ticketNumber }</span>. You cannot call another ticket at this time.</div>
                        :   null
                }
                {
                    isTransfered && !isTransferedToMysupportDeskId && !isTransferedToMyAgentId
                        ?   <div className="alertContainer scheme-pinkred-bg">
                                Ticket can only be managed by
                                {
                                    isTransferedToCounter
                                        ?   <> Counter: <span>"{ supportDesk.type }"</span></>
                                        :   ""
                                }
                                {
                                    isTransferedToAgent
                                        ?   <> the Agent: <span>"{ agent.name } { agent.lastname }"</span></>
                                        :   ""
                                }

                            </div>
                        :   null
                }
                {
                    isRedZoneTicket
                        ?   <div className="alertContainer scheme-pinkred-bg">
                                Red Zone: you are managing another agent's active ticket.
                            </div>
                        :   null
                }

                <div className="informationContainer" style={minHeight}>
                    {
                        reissueInfo
                            ?   <div className="informationRow reissueTicketNotice">
                                    <label>Ticket Type</label>
                                    <span>Re-assigned Ticket</span>
                                </div>
                            :   null
                    }
                    <div className="informationRow">
                        <label>Ticket Number</label>
                        <span>{ ticket.ticketLetter }{ ticket.ticketNumber }</span>
                    </div>
                    {
                        reissueInfo
                            ?   <div className="informationRow">
                                    <label>Re-assigned From</label>
                                    <span>{ reissueInfo.reissuedFromLabel }</span>
                                </div>
                            :   null
                    }
                    {
                        reissueInfo
                            ?   <div className="informationRow">
                                    <label>Original Ticket</label>
                                    <span>{ reissueInfo.originalTicketLabel }</span>
                                </div>
                            :   null
                    }
                    <div className="informationRow">
                        <label>Service</label>
                        <span>{ serviceName }</span>
                    </div>
                    {
                        isActiveTicket
                            ?   <div className="informationRow">
                                    <label>Service Time</label>
                                    <span><Time created = { ticket.sessionStart } /></span>
                                </div>
                            :   null
                    }
                    <div className="informationRow">
                        <label>Total In-branch Time</label>
                        <span><Time created = { queueCreated } /></span>
                    </div>
                    <div className="informationRow">
                        <label>{ reissueInfo ? 'Original Arrival Time' : 'Customer Arrival Time' }</label>
                        <span><TimeFormatter created = { queueCreated } /></span>
                    </div>
                </div>

                <div className="informationContainer" style={minHeight}>
                    <div className="informationRow">
                        <label>Full Name</label>
                            {
                                customer != null
                                    ?   !customer.fullname.length
                                        ?   <span>No Customer details</span>
                                        :   <span>{customer.fullname}</span>
                                    :   <span>Unavailable</span>
                            }
                    </div>
                    <div className="informationRow">
                        <label>Mobile Number</label>
                            {
                                customer != null
                                    ?   !customer.mobileNumber.length
                                        ?   <span>Unavailable</span>
                                        :   <span>{customer.mobileNumber}</span>
                                    :   <span>Unavailable</span>
                            }
                    </div>
                    {
                        customer != null
                            ?   customer.email != null
                                ?   customer.email.length === 0
                                        ?   null
                                        :   (
                                                <div className="informationRow">
                                                    <label>Email</label>
                                                    <span>{ customer.email }</span>
                                                </div>
                                            )
                                :   null
                            :   null
                    }
                </div>

                {
                    // Agent details for active tickets
                    isActiveTicket
                        ?   (
                                <div className="informationContainer" style={minHeight}>
                                    <div className="informationRow">
                                        <label>Agent</label>
                                        <span>
                                            { agent.name } { agent.lastname } 
                                            {
                                                ticket.manage.userId === authenticatedUser.id
                                                    ?   <span className="pill scheme-green-bg">You</span>
                                                    :   null
                                            }
                                        </span>
                                    </div>
                                    <div className="informationRow">
                                        <label>Counter</label>
                                        <span>{ ticket.manage.supportDesk.type } { ticket.manage.supportDesk?.number }</span>
                                    </div>
                                </div>
                            )
                        :   null
                }
                
                
                {
                    lock === MANAGEMENT_LOCK.default
                    ?   <div className="ticketActions group">
                            {
                                callStatus && 
                                ( 
                                    // make sure you cannot call inactive ticket while there is already an active one
                                    activeTicketId == null || 
                                    (activeTicketId != null && isActiveTicket )  
                                )                  
                                    ?   <CallTicket />
                                    :   null
                            } 
                            {
                                isMyActiveTicket || isRedZoneTicket
                                    ?   <CompleteTicket ticketId={ticket.id} supervisorOverride={isRedZoneTicket} />
                                    :   null
                            }
                            {
                                isMyActiveTicket || isRedZoneTicket
                                    ?   <TransferTicket ticketId={ticket.id} supervisorOverride={isRedZoneTicket} />
                                    :   null
                            }
                            {
                                isMyActiveTicket || isRedZoneTicket
                                    ?   <NoShowTicket ticketId={ticket.id} supervisorOverride={isRedZoneTicket} />
                                    :   null
                            }
                            {
                                isMyActiveTicket
                                    ?   <ReQueueTicket />
                                    :   null
                            }
                            {
                                isMyActiveTicket
                                    ?   <ReissueTicket />
                                    :   null
                            }
                            <div className="actionButtonContainer">
                                <div className="actionButton scheme-gray-bg">
                                    <div>
                                        <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.35806 9.17375L1.97236 9.54651L2.33766 8.87157C3.1612 7.49238 5.68153 4.27425 11.2589 4.27425C16.9745 4.27425 19.4099 7.76921 20.2101 8.91929L20.6156 9.55049L21.8889 8.74732L21.4645 8.08332C21.0232 7.44466 20.0967 6.11865 18.4437 4.9472C16.4353 3.51979 14.0173 2.79565 11.2589 2.79565C4.89377 2.79565 1.98031 6.52868 1.02059 8.12606L0.654297 8.74732L1.21939 9.08827C1.24509 9.10836 1.27216 9.12662 1.30041 9.14294C1.31907 9.15421 1.33832 9.16449 1.35806 9.17375V9.17375Z" />
                                            <path d="M17.3832 7.7692C15.6168 6.33136 13.5006 5.56995 11.2591 5.56995C6.41225 5.56995 3.19213 8.8502 2.14742 12.1041C1.19069 15.109 2.35368 19.4633 2.40239 19.6497L2.62008 20.336L4.10762 20.0165L3.87204 19.271C3.8616 19.2337 2.77365 15.1493 3.60316 12.5509C4.05047 11.1553 4.98136 9.79749 6.15529 8.83379C7.57177 7.67328 9.33813 7.05749 11.2591 7.05749C15.761 7.05749 18.3131 10.5669 19.0347 12.4306C19.5949 13.8685 19.4657 15.5031 18.7226 16.5061C18.4478 16.8734 17.9632 17.3048 17.2256 17.2675C15.5453 17.182 15.2545 16.3515 14.8504 14.7701C14.6566 14.0086 14.4578 13.2204 13.9623 12.5832C13.3589 11.8004 12.4812 11.4222 11.2645 11.4222C9.95591 11.4222 8.96488 11.8536 8.3133 12.7005C6.89186 14.5534 7.81629 17.7168 7.85556 17.85L7.86649 17.8923C7.93657 18.0841 9.65969 22.6958 14.2744 23.8404L15.0085 24L15.4106 22.5731L14.6516 22.4026C10.9628 21.4866 9.42262 17.7113 9.30433 17.4131C9.17101 16.9292 9.0861 16.4333 9.05086 15.9326C8.99718 15.2139 9.03496 14.2233 9.51954 13.5897C9.8749 13.1264 10.446 12.9028 11.2591 12.9028C12.7396 12.9028 12.9877 13.6269 13.3753 15.1289C13.7521 16.5931 14.2699 18.6005 17.1446 18.7446C18.2485 18.7978 19.245 18.3078 19.9448 17.3704C20.9949 15.9649 21.1942 13.8133 20.4512 11.8964C19.8707 10.3874 18.751 8.88747 17.3832 7.7692V7.7692Z" />
                                            <path d="M6.1983 16.2626C6.02584 14.857 6.26838 12.7338 7.51785 11.3531C8.38463 10.3944 9.64455 9.91182 11.2549 9.91182C13.1181 9.91182 14.5286 10.7428 15.4551 12.3775C15.911 13.1977 16.2123 14.0948 16.3437 15.024L16.4148 15.7541L17.9058 15.6448C17.9072 15.3855 17.8906 15.1265 17.8561 14.8695C17.8506 14.8059 17.6787 13.2562 16.8124 11.7011C15.6166 9.55845 13.6996 8.42428 11.2588 8.42428C9.19625 8.42428 7.55364 9.07934 6.38517 10.3681C4.8022 12.1146 4.47915 14.6548 4.69982 16.449V16.4654C5.09594 19.1755 6.13965 21.343 7.98603 23.2813L8.56256 23.839L9.60379 22.756L9.08989 22.2694C7.46368 20.5657 6.54272 18.6592 6.1983 16.2626V16.2626ZM5.1193 2.81605C5.66998 2.48206 7.61775 1.48556 11.2588 1.48556C15.6096 1.48556 17.543 2.91296 17.5644 2.9234L18.2552 3.36375L19.0618 2.11079L18.4048 1.68535C18.379 1.66647 18.3521 1.64758 18.3253 1.62969C17.6951 1.21966 15.4605 0 11.2588 0C6.89958 0 4.66105 1.31608 4.13124 1.67541L3.45581 2.11328L4.26096 3.36623L5.1193 2.81605Z" />
                                            <path d="M17.9482 19.841C16.2896 20.0274 14.9437 19.7083 13.9368 18.9041C12.2351 17.5408 12.0144 15.1711 12.0089 15.1269L11.9478 14.3873L10.4304 14.4982L10.4955 15.2437C10.5065 15.3659 10.754 18.263 12.9617 20.0418C14.0606 20.9309 15.4338 21.3782 17.0491 21.3782C17.4072 21.3775 17.765 21.3561 18.1206 21.3141L18.9452 21.2102L18.642 19.7336L17.9482 19.841Z" />
                                        </svg>
                                    </div>
                                    <span>History</span>
                                </div>
                            </div>

                        </div>
                    :   <div className="ticketActions group">
                            {
                                callStatus && 
                                ( 
                                    // make sure you cannot call inactive ticket while there is already an active one
                                    activeTicketId == null || 
                                    (activeTicketId != null && isActiveTicket )  
                                )                  
                                    ?   <AssistTicketDirect ticket={ticket} />
                                    :   null
                            } 
                            {
                                isMyActiveTicket
                                    ?   <ReQueueTicket />
                                    :   null
                            }
                            {
                                isMyActiveTicket
                                    ?   <ReissueTicket />
                                    :   null
                            }
                        </div>
                }
            </>
        )
    }
}

const mapStateToProps = state => {
    const { auth, tickets, users, sessions, customers, services } = state
    return {
        authenticatedUser: auth.authenticatedUser,
        supportDeskId: auth.supportDeskId,
        tickets: tickets.tickets,
        activeTicketId: tickets.activeTicketId,
        activeManagementTicketId: tickets.activeManagementTicketId,
        sessions: sessions.sessions,
        supportDesks: services.supportDesks,
        users: users.users,
        customers: customers.customers,
        services: services.services,

    }
}
  
export default connect(mapStateToProps, {})(TicketManagement);
